import Stack from '@mui/material/Stack';
import { Getter } from "../../../services/ComService"
import { useEffect, useState } from 'react';
import { Status } from '../day/dayView';
import Spinner from '../../../components/Spinner/Spinner';
import ItemPersonDTO, { IItemPerson } from '../../DTO/ItemPersonDTO';
import { parseStringFromServer } from '../../../services/TextConverter';
import { Box, Card, CardContent, Typography } from '@mui/material';
import ReportIcon from '@mui/icons-material/Report';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

interface Conflict {
  id: number,
  name: string,
  eventId: number,
  eventName: string,
  eventDate: string,
}
interface PersonWithConflicts {
  person: {
    id: number,
    firstname: string,
    lastname: string,
    email: string,
  },
  Person?: ItemPersonDTO,
  conflicts: Conflict[],
}

export default function ModulePersonConflicts({
  id,
}: {
  id: number,
}) {
  const [status, setStatus] = useState(Status.loading)
  const [conflicts, setConflicts] = useState<PersonWithConflicts[]>([])
  const renewConflicts = async () => {
    setStatus(Status.loading)
    Getter('EventModulePersonConflict/' + id).then((data) => {
      console.log('EventModulePersonConflict', data)
      setConflicts(data.personConflicts.map((pc: PersonWithConflicts) => {
        return {
          ...pc,
          conflicts: pc.conflicts.filter(pc => pc.name),
          Person: new ItemPersonDTO(pc.person as IItemPerson),
        }
      }).filter((c: PersonWithConflicts) => c.conflicts.length > 0))
      setStatus(Status.standard)
    })
  }
  useEffect(() => {
    renewConflicts()
  }, [id])
  const headline = <h2>Sequenz / Person Konflikte</h2>
  if (status === Status.loading) {
    return <>
      {headline}
      <Spinner />
    </>
  }
  return <Stack
    spacing={2}
    sx={{
      backgroundColor: '#fff',
      padding: 4,
    }}
  >
    {headline}

    {
      conflicts.length === 0 &&
      <Box>
        <p><b><CheckCircleIcon /> Keine Konflikte gefunden</b></p>
      </Box>
    }
    {
      conflicts.map((conflict: PersonWithConflicts) => {
        return <Card
          key={conflict.person.id}
          sx={{
            backgroundColor: 'grey.100',
          }}
        >
          <CardContent>
            <Typography variant="h5" component="div" sx={{
              marginBottom: 2,
            }}>
                <ReportIcon /> {conflict.Person!.getDisplayName()}
            </Typography>
            <Stack
              spacing={2}
            >
              {
                conflict.conflicts.map((c: Conflict) => {
                  return <Stack
                    key={c.id}
                    direction={'row'}
                    spacing={2}
                    sx={{
                      
                    }}
                  >
                    <Box>&rarr; {parseStringFromServer(c.eventName)}</Box>
                    <Box>{parseStringFromServer(c.name)}</Box>
                  </Stack>
                })
              }
            </Stack>
          </CardContent>
        </Card>
      })
    }
  </Stack>
}